import React from 'react';
import TimesheetDetailTimeButton from './TimesheetDetailTimeButton';
import TimesheetDetailContractPhaseButton from './TimesheetDetailContractPhaseButton';
import TimesheetDetailTimeDisplay from './TimesheetDetailTimeDisplay';
import cls from 'classnames';

export default class TimesheetDetailRow extends React.Component {
    render() {
        const { loading, timesheetDetail, timesheet } = this.props;

        if (loading || !timesheetDetail) {
            return null;
        }

        const { employee, equipment } = timesheetDetail;

        const isAttachedEquipment = equipment?.id > 0;

        return (
            <div
                className={cls('timesheet-detail-row', 'row', 'd-flex', {
                    'equipment-row': isAttachedEquipment,
                })}
            >
                <div
                    className={cls('col-2', { 'd-flex': isAttachedEquipment })}
                >
                    {isAttachedEquipment && <div className="elbow-div"></div>}

                    <div>
                        <TimesheetDetailTimeButton
                            {...this.props}
                            employee={employee}
                            equipment={equipment}
                        />
                    </div>
                </div>

                {timesheet.timesheetContractPhases.map((tcp) => {
                    const timesheetDetailContractPhaseAdjustment =
                        timesheetDetail.timesheetDetailContractPhaseAdjustments.find(
                            (tdcpa) =>
                                tdcpa.contractPhaseId == tcp.contractPhaseId
                        );

                    if (timesheetDetailContractPhaseAdjustment) {
                        return (
                            <TimesheetDetailContractPhaseButton
                                key={`tdcpbd-${timesheetDetailContractPhaseAdjustment.contractPhaseId}-${timesheetDetailContractPhaseAdjustment.timesheetDetailId}`}
                                timesheetDetailContractPhaseAdjustment={
                                    timesheetDetailContractPhaseAdjustment
                                }
                                {...this.props}
                            />
                        );
                    }

                    const timesheetDetailContractPhase =
                        timesheetDetail.timesheetDetailContractPhases.find(
                            (tdcp) =>
                                tcp.contractPhaseId == tdcp.contractPhaseId
                        );

                    return (
                        <TimesheetDetailContractPhaseButton
                            key={`tdcpbd-${timesheetDetailContractPhase.contractPhaseId}-${timesheetDetailContractPhase.timesheetDetailId}`}
                            timesheetDetailContractPhase={
                                timesheetDetailContractPhase
                            }
                            {...this.props}
                        />
                    );
                })}

                {timesheet.timesheetContractPhaseAdjustments
                    .filter(
                        (tcpa) =>
                            !timesheet.timesheetContractPhases.some(
                                (tcp) => tcpa.timesheetContractPhaseId == tcp.id
                            )
                    )
                    .map((tcpa) => {
                        const timesheetDetailContractPhaseAdjustment =
                            timesheetDetail.timesheetDetailContractPhaseAdjustments.find(
                                (tdcpa) =>
                                    tdcpa.contractPhaseId ==
                                    tcpa.contractPhaseId
                            );

                        return (
                            <TimesheetDetailContractPhaseButton
                                key={`tdcpbd-${timesheetDetailContractPhaseAdjustment.contractPhaseId}-${timesheetDetailContractPhaseAdjustment.timesheetDetailId}`}
                                timesheetDetailContractPhaseAdjustment={
                                    timesheetDetailContractPhaseAdjustment
                                }
                                {...this.props}
                            />
                        );
                    })}

                <div className="grid-col"></div>

                <div className="grid-col">
                    <TimesheetDetailTimeDisplay {...this.props} />
                </div>
            </div>
        );
    }
}
